"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nProvider = void 0;
exports.useG11nBidirectionalStateManager = useG11nBidirectionalStateManager;
exports.useI18nContext = void 0;
var _reactI18next = require("react-i18next");
var _react = require("react");
var _usePrevious = _interopRequireDefault(require("@livongo/utilities/hooks/usePrevious"));
var _g11n = require("../../App/g11n");
var _jsxRuntime = require("react/jsx-runtime");
const I18nContext = /*#__PURE__*/(0, _react.createContext)();
const I18nProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const [lang, setLang] = (0, _react.useState)(i18n.language);
  const value = (0, _react.useMemo)(() => ({
    CODES: _g11n.CODES,
    selectedLang: lang,
    selectedCountry: lang.slice(3),
    scopedLangCodes: _g11n.CODES.LANGUAGES.filter(code => code.indexOf(lang.slice(2)) > 1),
    changeLanguage: code => {
      if (_g11n.CODES.LANGUAGES.indexOf(code) === -1) {
        throw new Error("".concat(code, " is not supported"));
      }
      setLang(code);
    }
  }), [lang]);
  (0, _react.useEffect)(() => {
    document.getElementsByTagName('html')[0].lang = lang;
    (0, _g11n.setStoredLang)(lang);
    if (lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(I18nContext.Provider, {
    value: value,
    children: children
  });
};
exports.I18nProvider = I18nProvider;
const useI18nContext = () => (0, _react.useContext)(I18nContext);

// there are cases we need i18n code in-sync with the project
// storybook for example has global lang code state for the toolbar
// member portal for example has a user preference lang code saved on the server
// this method will:
// 1) compare old and new values with itself (to see which direction the lang code changed)
// 2) listen for changes with the pulse lang code state
// 3) listen for changes with the project's secondary lang code state
// 4) and update the correct direction with the proper lang code
// the second argument should be a memoized method either via useMemo or
// a function that lives outside of the functional component
// or else this will fire unnecessarily behind the scenes (no bad outcome, just more performant)
exports.useI18nContext = useI18nContext;
function useG11nBidirectionalStateManager(code, updater) {
  const {
    selectedLang,
    changeLanguage
  } = useI18nContext();
  // one variable is the pulse i18n lang code state
  // the updater, is the project's function to update
  const one = (0, _react.useMemo)(() => ({
    code: selectedLang,
    updater
  }), [selectedLang, updater]);
  // two variable is the project's i18n lang code state
  // the updater, is the pulse i18n function to update
  const two = (0, _react.useMemo)(() => ({
    code,
    updater: changeLanguage
  }), [code, changeLanguage]);
  const prev = (0, _usePrevious.default)({
    one: one.code,
    two: two.code
  });
  (0, _react.useEffect)(() => {
    const hasOneChanged = (prev === null || prev === void 0 ? void 0 : prev.one) !== one.code;
    const hasTwoChanged = (prev === null || prev === void 0 ? void 0 : prev.two) !== two.code;
    const isTheSame = one.code === two.code;
    const final = hasOneChanged ? one : hasTwoChanged ? two : false;

    // final could be false due to other deps changing
    // also due to deps changing, the codes might be the same
    if (final !== null && final !== void 0 && final.code && !isTheSame) {
      // finally update the other direction's state
      final.updater(final.code);
    }
  }, [one, two, prev, code, selectedLang]);
  return;
}